function initResults() {
  const resultsSwiper = new Swiper(".results__swiper", {
    slidesPerView: 'auto',
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        allowTouchMove: false,
        spaceBetween: 10,
        direction: 'vertical',
      },
      1280: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        allowTouchMove: true,
      }
    }
  });
}

export { initResults };
